const LOGO = 'https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png';
const LOGO_WHITE = 'https://bboneapp.s3.amazonaws.com/evo-white.png';
const SMS = 'SMS';
const WHATSAPP = 'WHATSAPP';
const BP_LOGO = 'https://bboneapp.s3.us-east-1.amazonaws.com/uploads/LOGO+SEGURADORA+1.svg';

module.exports = {
  LOGO,
  LOGO_WHITE,
  SMS,
  WHATSAPP,
  BP_LOGO,
};
